// @vue/component
import {useChallengeStore} from "@/stores/WheelAnalysis/challenge";
import {useKeywordStore} from "@/stores/WheelAnalysis/keyword";
import {storeToRefs} from "pinia";


export default {
  name: 'KeywordView',

  components: {},

  mixins: [],

  props: {},

  setup() {
    const keywordStore = useKeywordStore()
    const challengeStore = useChallengeStore()

    const { keyword1 } =  storeToRefs(keywordStore)
    const { keyword2 } =  storeToRefs(keywordStore)
    const { keyword3 } =  storeToRefs(keywordStore)

    const { challengeStatement } =  storeToRefs(challengeStore)
    const { editMode } =  storeToRefs(challengeStore)

    return { keywordStore, challengeStore, keyword1, keyword2, keyword3, challengeStatement, editMode }

  },

  mounted () {
    this.keywordStore.fetchWheelAnalysis()
    this.challengeStore.fetchWheelAnalysis()
  },

  computed: {},

  methods: {}
}
